/**
 * Returns only the values in object that have different value then original
 *
 * Note: Only supports flat objects for now
 *
 * @param initialValues old values
 * @param newValues new values
 */
export function getChangedValues<T extends object>(initialValues: any, newValues: any): T {
  return Object.keys(newValues).reduce<T>((initial, key) => {
    if (newValues[key] !== initialValues[key]) {
      return {
        ...initial,
        [key]: newValues[key],
      };
    }

    return initial;
  }, {} as T);
}
